/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import moment from "moment";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TimelineList from "../TimelineList";
import TimelineItem from "examples/Timeline/TimelineItem";
import SoftTypography from "components/SoftTypography";

function ClearwayTimeline({ data, groupID }) {
    var now = moment().unix();

    var upcoming_events = data.filter((event) => {
        var ret = {};

        for (var group of event.groups) {
            if (Number(group.group_id) == groupID) {
                ret.event = event;
                ret.event.exception = group.exception;
                return ret;
            }
        }
    }).filter(event => moment(event.end_time).unix() > now);

    const renderTimelineItems = upcoming_events.map((event, index) => {
        var row = {};

        if (moment(event.display_time).unix() > now) { // not active at all
            row.color = "secondary";
            row.icon = "archive";
            row.dateTime = moment(event.start_time).format("DD/MM/YY hh:mm a") + ' - ' + moment(event.end_time).format("DD/MM/YY hh:mm a");
            row.description = "Event displaying from " + moment(event.display_time).format("DD/MM/YY hh:mm a");
            row.badges = ["inactive"];
        }
        else if (moment(event.start_time).unix() > now) { // displaying but not active
            row.color = "warning";
            row.icon = "notifications";
            row.dateTime = moment(event.start_time).format("DD/MM/YY hh:mm a") + ' - ' + moment(event.end_time).format("DD/MM/YY hh:mm a");
            row.description = "Event starting " + moment(event.start_time).format("DD/MM/YY hh:mm a");
            row.badges = ["warning"];
        }
        else if (moment(event.start_time).unix() < now) { // active
            row.color = "info";
            row.icon = "campaign";
            row.dateTime = moment(event.start_time).format("DD/MM/YY hh:mm a") + ' - ' + moment(event.end_time).format("DD/MM/YY hh:mm a");
            row.description = "Event finishing " + moment(event.end_time).format("DD/MM/YY hh:mm a");
            row.badges = ["active"];
        }

        if (event.exception != null && event.exception != '') {
            row.badges.push(event.exception.replace("_", " "));
        }

        row.title = event.name;
        row.lastItem = upcoming_events.length - 1 == index ? true : false;

        return (<TimelineItem
            key={row.title + row.color}
            color={row.color}
            icon={row.icon}
            title={row.title}
            dateTime={row.dateTime}
            description={row.description}
            badges={row.badges}
            lastItem={row.lastItem}
        />)
    });

    // console.log(renderTimelineItems)

    return (
        <SoftBox>
            <TimelineList title="Clearway Timeline" subtitle={moment().format("DD/MM/YYYY")}>
                {renderTimelineItems.length > 0 && (renderTimelineItems)}
                {renderTimelineItems.length == 0 && (
                    <SoftBox p={2} pl={3}>
                        <SoftTypography variant="h5">
                            Not In Use!
                        </SoftTypography>
                    </SoftBox>
                )}
            </TimelineList>
        </SoftBox>
    );
}


// Typechecking props for the Calendar
ClearwayTimeline.propTypes = {
    data: PropTypes.array,
    groupID: PropTypes.number
};

export default ClearwayTimeline;